import React from "react";
import { LegalDisclaimer } from "./LegalDisclaimer";

const Footer = () => {
    return (
        <footer className="px-4 pt-6 pb-4 flex flex-col items-center gap-3" data-testid="site-footer">
            <LegalDisclaimer variant="compact" />
            <a
                href="https://t.me/ilverolupin"
                target="_blank"
                rel="noreferrer"
                data-testid="created-by-button"
                title="Vuoi un sito simile? Scrivimi"
                className="inline-flex items-center gap-1.5 rounded-full bg-[#150826]/70 backdrop-blur border border-[#7c3aed]/50 px-3 py-1 text-[10px] font-mono tracking-widest text-white/40 hover:border-[#e879f9] hover:text-white hover:shadow-[0_0_12px_rgba(232,121,249,0.4)] active:scale-95 transition-all"
            >
                <span>creato da</span>
                <span className="text-[#e879f9] normal-case tracking-normal font-semibold">
                    @ilverolupin
                </span>
            </a>
        </footer>
    );
};

export default Footer;
